import { render, staticRenderFns } from "./CompetenceView.vue?vue&type=template&id=6f27148b&scoped=true"
import script from "./CompetenceView.vue?vue&type=script&lang=js"
export * from "./CompetenceView.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=6f27148b&prod&scoped=true&lang=css&external"
import style1 from "./CompetenceView.vue?vue&type=style&index=1&id=6f27148b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27148b",
  null
  
)

export default component.exports